import { PredictedLineupsDetail, IPredictedLineupsDetail, ActiveTabType, ITeam } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { MatchPredictedLineupsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";
import { useEffect, useState } from "react";
import { transformPlayersInFormationImages } from "../../utils/match-predicted-lineups";
import { isValidObject } from "../../utils/tests";
import { isClient } from "../../utils/client";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<MatchPredictedLineupsQuery>) => {
  return {
    variables: JSON.stringify(variables),
    headshothash: variables.headshothash,
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<MatchPredictedLineupsQuery>): IPredictedLineupsDetail => {
  return transformer(props);
}

export const urlPathReplace = (pathname: string, path: string): string =>
  `${pathname.substring(0, pathname.lastIndexOf('/'))}/${path}`;

export const urlUpdate = (seoName: string, _location: Location = location, _history: History = history): void => {
  // const urlCurrent: URL = new URL(_location.href);
  const { hash, href, host, pathname, protocol } = _location;
  const urlUpdated = `${protocol}//${host}${urlPathReplace(pathname, seoName)}${hash}`;

  if (href !== urlUpdated) {
    _history.pushState({}, '', urlUpdated); // Only if URL is CHANGED!
  }
};

const MatchPredictedLineupsWidget = ({
  props,
  ...rest
}: WidgetContext<IPredictedLineupsDetail>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();
  const [transformedArgs, setTransformedArgs] = useState<IPredictedLineupsDetail>();

  const getUrlLastPath = (): string => isClient() ? location.pathname.substring(location.pathname.lastIndexOf('/') + 1) : '';
  const isTeamAway = (): boolean =>
    props && props.away && props.away.seoName ? props.away.seoName.toLowerCase() === getUrlLastPath().toLowerCase() : false;
  const [activeTab, setActiveTab] = useState<ActiveTabType>(isTeamAway() ? 'away' : 'home');

  const isValidPayload = (args: IPredictedLineupsDetail): boolean => Boolean(args.away && args.home);

  useEffect(() => {
    if (isValidObject(props) && isValidPayload(props)) {
      const team: ITeam = props[activeTab];
      if (team && team.seoName) {
        urlUpdate(team.seoName); // URL UPDATE when HOME/AWAY tab is CLICKED (and SEO NAME is AVAILABLE)
      }
    }
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!props) {
      return;
    }

    const hydratedArgs: IPredictedLineupsDetail = transformPlayersInFormationImages({ args: props, headshothash: rest.variables.headshothash });
    setTransformedArgs(hydratedArgs);
  }, [props, rest.variables.headshothash]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div onClick={intCmpEventHandler}>
        {transformedArgs ? (
          <PredictedLineupsDetail activeTab={activeTab} onTabChange={setActiveTab} {...transformedArgs}/>
        ) : <PredictedLineupsDetail activeTab={activeTab} onTabChange={setActiveTab} {...props}/>}
    </div>
  );
}

export default MatchPredictedLineupsWidget;